export default [
	{
		type: "text",
		id: 1,
		title: "Personal details",
		items: [
			{
				id: 1,
				text: "Semester: ",
				type: "small",
			},
			{
				id: 2,
				text: "Field of study: ",
				type: "medium",
			},
		],
	},
	{
		type: "special",
		id: 2,
		items: [
			{
				id: 3,
				text: "Participation: ",
				label: [
					{
						id: 1,
						text: "Pflicht-LV",
					},
					{
						id: 2,
						text: "Wahlpflicht-LV",
					},
					{
						id: 3,
						text: "Wahl-LV",
					},
				],
			},
		],
	},
	{
		type: "uni",
		id: 4,
		items: [
			{
				id: 4,
				text: "The course was well structured and comprehensible.",
			},
			{
				id: 5,
				text: "The structure of the content was logical/easy to follow.",
			},
			{
				id: 6,
				text: "The documents have deepened the understanding of the contents of the lecture.",
			},
			{
				id: 7,
				text: "The learning objective was clear to me.",
			},
			{
				id: 8,
				text: "The level of difficulty of the material was appropriate.",
			},
			{
				id: 9,
				text: "The amount of material was appropriate for the time frame.",
			},
			{
				id: 10,
				text: "The necessary prior knowledge for the course was adequate.",
			},
			{
				id: 11,
				text: "The amount of time required for the course (including preparation and follow-up) was appropriate.",
			},
			{
				id: 12,
				text: "I have benefited from having attended the course regularly.",
			},
			{
				id: 13,
				text: "The course fulfilled my expectations.",
			},
			{
				id: 14,
				text: "I learned a lot in this course.",
			},
			{
				id: 15,
				text: "Overall, this was a good course.",
			},
		],
	},
	{
		type: "text",
		id: 5,
		items: [
			{
				id: 16,
				text: "Further remarks regarding the course (praise/criticism)",
				size: "default",
			},
		],
	},
	{
		type: "dsp",
		id: 6,
		items: [
			{
				id: 17,
				text: "The lecturer was able to respond competently to questions.",
			},
			{
				id: 18,
				text: "The lecturer was enthusiastic and motivated.",
			},
			{
				id: 19,
				text: "The lecturer provided a good learning and working atmosphere.",
			},
			{
				id: 20,
				text: "The lecturer was able to convey the learning content in an understandable way.",
			},
		],
	},
];
